import React, {useState} from "react";
import {placeholderRegularTextStyles} from "../Style";
import autosureLogo from "../images/autosure-logo.png"
import veroLogo from "../images/Vero-Logo.png";

const Footer = props => {
    const [privacyRedirect, setPrivacyRedirect] = useState(false);
    const [termsOfUsePopupShow, setTermsOfUsePopupShow] = useState(false);
    const onPrivacyLinkClick = () => {
        setPrivacyRedirect(true);
    }
    const onTermsOfUseLinkClick = () => {
        setTermsOfUsePopupShow(true);
    }
    const openInNewTab = (url) => {
        const newWindow = window.open(url, "_blank");
        newWindow.focus();
    };

    if (privacyRedirect) {
        openInNewTab("https://autosure.co.nz/privacy-policy/");
    }
    if (termsOfUsePopupShow) {
      openInNewTab("https://autosure.co.nz/terms-of-use/");
    }
    return (<>
        <div style={{display: "flex", alignItems: "flex-start",overflow:"hidden"}}>
            <div className="footerMobile footerPadding footerFixed" style={placeholderRegularTextStyles}>
              <div className="column-on-mobile" style={{
                    display: "flex",
                    justifyContent: 'space-evenly',
                    paddingTop: '16px',
                    alignItems: "center",
                    paddingBottom: '8px'
                }}>
                <div style={{margin: 0}}>
                  This insurance is provided by Vero Insurance New Zealand Limited and brought to you by {" "}
                  <span
                    className="spanLink"
                    onClick={() => openInNewTab("https://autosure.co.nz/")}
                  > Autosure Insurance Limited </span>
                  <br/>
                        <span className='spanLink' onClick={() => {
                            window.location = "tel:0800262411"
                        }}>0800 262 411</span> | <span className='spanLink' onClick={() => {
                        window.location = "mailto:support@autosure.co.nz"
                    }}>support@autosure.co.nz </span>| © Autosure Insurance Limited
                        | <span className='spanLink'
                                onClick={onPrivacyLinkClick}>Privacy</span> |{' '}
                        <span className="spanLink" onClick={onTermsOfUseLinkClick}>
            Terms of Use
        </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div>
                        <a href="https://autosure.co.nz/" target="_blank" rel="noopener noreferrer">
                          <img src={autosureLogo} style={{width: "100px", cursor: "pointer"}} alt="Autosure Logo"/>
                        </a>
                      </div>
                        <div style={{ width: "2px", height: "100px", background: "#CCCCCC", margin: "0 10px" }}></div>
                      <div>
                        <a href="https://www.vero.co.nz/" target="_blank" rel="noopener noreferrer">
                          <img src={veroLogo} style={{width: "100px", cursor: "pointer"}} alt="veroLogo"/>
                        </a>
                      </div>
                    </div>

                </div>
            </div>
        </div>
    </>);
}

export default Footer;
